import { FlightsFilterType, FlightsListDisplayFilterItem, FlightsCardsDisplayFilterItem } from '__generated__/api';

export const FILTER_TYPE_TO_ID_PREFIX: { [key in FlightsFilterType]: string } = {
  ARRIVAL_AIRPORT: 'arrival-airport',
  ARRIVAL_TIME: 'arrival-time',
  DEPARTURE_AIRPORT: 'departure-airport',
  DEPARTURE_TIME: 'departure-time',
  DURATION: 'duration',
  NUM_OF_STOPS: 'stops',
  PREFERRED_AIRLINE: 'preferred-airline',
  FLEXIBLE_CHANGE_POLICIES: 'flexible-change-policy',
  SEAT_CHOICE: 'seat-choice',
  CARRY_ON_BAG: 'carry-on-bag',
  CHECKED_BAG: 'checked-bag',
  NO_CANCEL_FEE: 'no-cancel-fee',
  NO_CHANGE_FEE: 'no-change-fee',
  TRAVEL_AND_BAGGAGE: 'travel-and-baggage',
  CREDIT_ELIGIBLE: 'credit-eligible',
  DEPARTURE_TIME_SLIDER: 'departure-time-slider',
  ARRIVAL_TIME_SLIDER: 'arrival-time-slider'
};

export const getFilterValue = (
  filterValue: FlightsCardsDisplayFilterItem.Value | FlightsListDisplayFilterItem.Value
) => {
  switch (filterValue.__typename) {
    case 'FlightsTimeBasedFilterValue':
      return filterValue.timeOfDay;
    case 'FlightsAirportCodeFilterValue':
      return filterValue.airportCode;
    case 'FlightsDurationBasedFilterValue':
      return filterValue.maxDuration;
    case 'FlightsStopBasedFilterValue':
      return filterValue.stopInfo.numberOfStops;
    case 'FlightsPreferredAirlineFilterValue':
      return filterValue.carrierCode;
    case 'FlightsFlexibleChangePolicyBasedFilterValue':
      return filterValue.policyName;
    case 'FlightsSeatChoiceBasedFilterValue':
      return filterValue.seatChoice;
    case 'FlightsCarryOnBagBasedFilterValue':
      return filterValue.carryOnBag;
    case 'FlightsCheckedBagBasedFilterValue':
      return filterValue.numOfCheckedBags;
    case 'FlightsNoCancelFeeBasedFilterValue':
      return filterValue.noCancelFee;
    case 'FlightsCreditEligibleFilterValue':
      return filterValue.creditEligible;
  }

  return null;
};

export const FILTER_HEIGHT_IN_PX = 35;
export const FILTER_FADE_THRESHOLD_FACTOR = 0.6;
